export default "__VITE_ASSET__C2ke77H6__"